import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute h-40 right-10 inset-y-12" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-xl font-semibold text-black py-0 my-0" }
const _hoisted_5 = { class: "mt-0 lg:mt-2 flex items-baseline text-gray-900 py-0 my-0" }
const _hoisted_6 = { class: "text-5xl font-extrabold tracking-tight font-poppins-bold" }
const _hoisted_7 = {
  role: "list",
  class: "mb-2 space-y-6 px-0 my-0 py-0"
}
const _hoisted_8 = { class: "flex my-0 py-0" }
const _hoisted_9 = { class: "text-black" }
const _hoisted_10 = { class: "mt-6 max-w-48 flex rounded-full bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark p-0.5 shadow-md" }
const _hoisted_11 = ["href"]

import { injectStrict } from '../../plugins/vueServiceContainerPlugin';
import { UtilityServiceInterface } from '../../services/utilityServiceInterface';

import { BrandServiceInterface } from '../../services/brand/brandServiceInterface';

type Product = {
  id: string,
  name: string,
  description: string,
  price: number,
  img?: string,
  imghover?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VoipSelectorProduct',
  props: {
    isSelectedProduct: { type: Boolean },
    product: {}
  },
  emits: ["handle-select-product"],
  setup(__props: any, { emit: __emit }) {

const utilityService = injectStrict<UtilityServiceInterface>('UtilityServiceInterface');
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');



const emit = __emit;

const handleSelectProduct = (product: Product) => {
  emit('handle-select-product', product);
};

const standardLinks: Array<{ name: string, link: string }> = [{
  name: 'Critical Information Summary',
  link: `https://uniti-bpo-website-assets.assets.unitiinternet.com/${brandService.getName()}/critical-information-summary-phone.pdf`
}];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSelectProduct(_ctx.product))),
    class: _normalizeClass(["font-poppins group relative my-2 lg:my-0 rounded-2xl flex flex-col bg-opacity-70 transition ease-in-out duration-100 hover:rounded-2xl hover:bg-gradient-to-tr hover:from-brand-primary-light hover:to-brand-primary-dark hover:p-1 cursor-pointer", { 'bg-opacity-100': !_ctx.isSelectedProduct, 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark p-1 shadow-md': _ctx.isSelectedProduct }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["transition ease-in-out group-hover:bg-white p-8 rounded-xl border-black border-solid border hover:border-none", [_ctx.isSelectedProduct? 'bg-white border-none' : 'bg-opacity-70 bg-white']])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "absolute right-0 opacity-100 group-hover:opacity-0 transition-opacity ease-in-out duration-300",
          src: _ctx.product.img
        }, null, 8, _hoisted_2),
        _createElementVNode("img", {
          class: "absolute right-0 opacity-0 group-hover:opacity-100 transition-opacity ease-in-out duration-300",
          src: _ctx.product.imghover
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("h3", _hoisted_4, "Talk " + _toDisplayString(_unref(utilityService).toTitleCase(_ctx.product.name)), 1),
      _createElementVNode("p", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, "$" + _toDisplayString(_ctx.product.price), 1),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ml-1 text-lg font-normal text-gray-900" }, "/Month", -1))
      ]),
      _createElementVNode("ul", _hoisted_7, [
        _createElementVNode("li", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.product.description), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: _normalizeClass(["cursor-pointer flex-1 text-18 group-hover:bg-transparent px-6 py-3 rounded-full font-poppins border-none", [_ctx.isSelectedProduct? 'bg-transparent' : 'bg-white']])
        }, _toDisplayString(_ctx.isSelectedProduct ? 'Selected' : 'Select Product'), 3)
      ]),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(standardLinks, (standardLink) => {
        return _createElementVNode("a", {
          key: standardLink.name,
          href: standardLink.link,
          target: "_blank",
          class: "block href font-bold text-black hover:text-brand-primary hover:underline transition duration-250 mt-6 text-sm"
        }, _toDisplayString(standardLink.name), 9, _hoisted_11)
      }), 64))
    ], 2)
  ], 2))
}
}

})